import { Component, OnInit, Output, EventEmitter, ElementRef, Input } from '@angular/core';


import { map, filter, debounceTime, tap, switchAll, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { fromEvent } from 'rxjs';

import { CustomerSearchResult } from 'src/app/core/models/customer-search-result';
import { SearchCustomerService } from 'src/app/core/services/search-customer.service';
import { SearchCustomerFilter } from 'src/app/core/interfaces/search-customer-filter';



@Component({
  selector: 'app-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss']
})
export class SearchBoxComponent implements OnInit {

  searchText: string = '';
  @Input() selectedItem: CustomerSearchResult;
  @Output() loading = new EventEmitter<boolean>();
  @Output() results = new EventEmitter<CustomerSearchResult[]>();
  @Output() selected = new EventEmitter<CustomerSearchResult>();


  constructor(private searchService: SearchCustomerService, private el: ElementRef) { }

  ngOnInit() {

    const searchText = sessionStorage.getItem('patientSearchText');
    if (searchText) {
      this.searchText = searchText;
    }


    // convert the `keyup` event into an observable stream
    fromEvent(this.el.nativeElement, 'keyup')
      .pipe(
        map((e: any) => e.target.value), // extract the value of the input
        filter(text => text.length > 1), // filter out if empty
        debounceTime(500), // only once every 500ms
        tap(() => this.loading.emit(true)), // enable loading
        map((query: string) => {
          // sessionStorage.setItem('patientSearchText', query);
          return this.searchService.search(this.getFilterData(query)); // search
        }),
        switchAll()) // produces values only from the most recent inner sequence ignoring previous streams
      .subscribe(  // act on the return of the search
        _results => {
          this.loading.emit(false); // indicates stop loading
          this.results.emit(_results); // emits an event containing the list of results
        },
        err => {
          console.log(err);
          this.loading.emit(false); // indicates stop loading

        },
        () => {
          this.loading.emit(false);
        }
      );


  }

  search(textInput){ 
    this.loading.emit(true);
    let text = textInput.value;
    this.searchService.search(this.getFilterData(text)).subscribe(result => { 
      this.results.emit(result);
      this.loading.emit(false);
    });
  }

  getFilterData(text): SearchCustomerFilter {
    return {
      FilterText: text,
      FilterPatients: true,
      FilterSuppliers: false,
      FilterPhoneBook: false,
      FilterActive: true,
      FilterInactive: false
    };
  }

  onSelect(eventData: CustomerSearchResult): void {
    // search-box
    this.selectedItem = eventData;
    this.selected.emit(eventData);
  }

}
